import React, { useEffect, useState } from 'react';
import {
  Typography,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Box,
  TextField,
  Checkbox,
} from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import SearchIcon from '@material-ui/icons/Search';
import { useDispatch, useSelector } from 'react-redux';
import { cmoMembersList } from '../../../../containers/actions/pharmaCo/purchaseOrderActions';
import { fetchReportedByList } from '../../../../containers/actions/common/qualityEventActions';

const icon = <CheckBoxOutlineBlankIcon fontSize='small' />;
const checkedIcon = <CheckBoxIcon fontSize='small' />;

const AddAssociatedTeamMembers = ({ selectedTeamMembers, handleChangeTeamMemberList, errors }) => {
  const dispatch = useDispatch();

  let membersList = useSelector((state) =>
    state.pcmp.common.QMS.fetchReportedByList
      ? state.pcmp.common.QMS.fetchReportedByList
      : []
  );

  useEffect(() => {
    dispatch(fetchReportedByList())
  }, [dispatch]);


  const handleSelectionChange = (event, value) => {
    //   console.log(value)
    //   handleChangeTeamMemberList(value)
    if (
      selectedTeamMembers.filter(
        (val) => val.saasUserID === value[0].saasUserID
      ).length === 0
    ) {
      handleChangeTeamMemberList( selectedTeamMembers.concat(value));
    } else {
      handleChangeTeamMemberList(
        selectedTeamMembers.filter(
          (val) => !(val.saasUserID === value[0].saasUserID)
        )
      );
    }
  };

  //console.log(selectedTeamMembers)

  return (
    <Box>
            <Typography variant='body2' style={{
    marginBottom: '0.5rem',
    fontSize: '85%',
    fontWeight: '500',
  }}>
              Select a team members{' '}
              <span style={{color:'red'}}>*</span>
          </Typography>
          <Autocomplete
          multiple
          id='checkboxes-tags-demo'
          disableCloseOnSelect
          value={[]}
          onChange={handleSelectionChange}
          options={membersList}
              getOptionLabel={(option) =>
                option.name ? `${option.name}(${option.roleName})` : ''
              }
          renderOption={(option) => {
            let selected =
            selectedTeamMembers.filter(
                (val) => val.saasUserID === option.saasUserID
              ).length > 0;
            return (
              <React.Fragment>
                <Checkbox
                  icon={icon}
                  checkedIcon={checkedIcon}
                  style={{ marginRight: 8 }}
                        checked={selected}
                />
                    {option.name ? `${option.name}(${option.roleName})` : ''}
              </React.Fragment>
            );
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              variant='outlined'
              InputProps={{
                ...params.InputProps,
                startAdornment: <SearchIcon />,
              }}
              // label='Select Options'
              placeholder='Start typing to search and select'
            />
          )}
        />

      {/* Display selected CMOs */}
      <Box mt={2}>
        <Typography variant='body1' style={{ marginBottom: '0.5rem' }}>
          Your selections
        </Typography>
        <Box
          style={{
            border: errors?.associatedTeamMembers
              ? '1px solid #f44336'
              : '1px solid #ccc',
            borderRadius: '4px',
            padding: '1rem',
            maxHeight: '150px',
            overflowY: 'auto', // Enable vertical scroll when selections exceed box height
            display: 'flex',
            flexDirection: 'column', // Stack items vertically
          }}
        >
          {selectedTeamMembers.length > 0 ? (
            selectedTeamMembers.map((val, index) => (
                <Typography
                  key={index}
                  variant='body2'
                  style={{ fontSize: '14px' }}
                >
                  {val.name}
                </Typography>
              ))
          ) : (
            <Typography variant='body2' style={{ color: '#aaa' }}>
              No selections available.
            </Typography>
          )}
        </Box>
        {errors?.associatedTeamMembers && (
          <Typography variant='caption' style={{ color: '#f44336' }}>
            {errors?.associatedTeamMembers}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default AddAssociatedTeamMembers;
